package com.swetdot.swetgram

import com.swetdot.swetgram.data.api.ClientInfo
import com.swetdot.swetgram.data.auth.SessionStore
import com.swetdot.swetgram.data.cache.createBrowserDatabase
import com.swetdot.swetgram.data.media.ImagePicker
import com.swetdot.swetgram.data.media.BrowserVoicePlayer
import io.ktor.client.HttpClient
import io.ktor.client.engine.js.Js

suspend fun createBrowserAppContainer(): AppContainer {
    val origin = js("window.location.origin") as String
    val socketOrigin = origin.replaceFirst("http", "ws")
    return AppContainer(
        sessionStorage = SessionStore(),
        engine = HttpClient(Js),
        clientInfo = ClientInfo(platform = "web", version = "1.0.0", build = "1"),
        driverFactory = createBrowserDatabase(),
        baseUrl = "$origin/api/v1",
        realtimeUrl = "$socketOrigin/connection/websocket",
    ).also {
        it.imagePicker = ImagePicker()
        it.voicePlayer = BrowserVoicePlayer()
    }
}
